import get from 'lodash/get'
import { Store } from 'redux/reducers'

export const systemProcessSelector = (state: Store) => get(state, 'system.process')
export const userInfoSelector = (state: Store) => state.user
export const calendarsSelector = (state: Store) => state.calendars
export const suppliersSelector = (state: Store) => state.suppliers
